var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FEE2E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2664 28.9981H10.7334C10.3761 28.9981 10.046 28.8075 9.86737 28.4981C9.68874 28.1887 9.68874 27.8075 9.86737 27.4981L19.1334 11.4981C19.3121 11.1892 19.642 10.999 19.9989 10.999C20.3558 10.999 20.6856 11.1892 20.8644 11.4981L30.1304 27.4981C30.3089 27.8074 30.309 28.1883 30.1306 28.4977C29.9522 28.807 29.6225 28.9977 29.2654 28.9981H29.2664ZM19.0004 23.9981V25.9981H19.9334H19.9984H20.0634H20.9984V23.9981H19.0004ZM19.0004 16.9981V21.9981H21.0004V16.9981H19.0004Z",
    fill: "#DB0A3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlert);
export default __webpack_public_path__ + "static/media/notification-alert.94df238c.svg";
export { ForwardRef as ReactComponent };